const commonStatusStyles = {
    fontWeight: 'bold',
    padding: '0 12px',
    marginLeft: '6px',
    borderRadius: '12px',
    textTransform: 'capitalize',
};

const statusColors = {
    paid: {
        ...commonStatusStyles,
        color: '#2ECC71',
        background: '#D4EFDF',
        border: 'solid #2ECC71 1px',
    },
    'partially paid': {
        ...commonStatusStyles,
        color: '#D68910 ',
        background: '#F9E79F',
        border: 'solid #D68910 1px',
    },
    unpaid: {
        ...commonStatusStyles,
        color: '#E74C3C',
        background: '#F4D0E8',
        border: 'solid #E74C3C 1px',
    },
};

export default statusColors;
